import MenuSharpIcon from "@mui/icons-material/MenuSharp";
import AppBar from "@mui/material/AppBar";
import Stack from "@mui/material/Stack";
import { styled } from "@mui/material/styles";
import { tabsClasses } from "@mui/material/Tabs";
import MuiToolbar from "@mui/material/Toolbar";
import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import logo from "../images/logo-with-caption.webp";
import MenuButton from "./menu-button.component";
import SideMenuMobile from "./side-menu-mobile.component";

const Toolbar = styled(MuiToolbar)({
  width: "100%",
  padding: "12px",
  display: "flex",
  flexDirection: "column",
  alignItems: "start",
  justifyContent: "center",
  gap: "12px",
  flexShrink: 0,
  [`& ${tabsClasses.flexContainer}`]: {
    gap: "8px",
    p: "8px",
    pb: 0,
  },
});

export default function AppNavbar() {
  const [open, setOpen] = React.useState(false);
  const location = useLocation();
  useEffect(() => {
    setOpen(false);
  }, [location]);

  const navigate = useNavigate();
  const toggleDrawer = (newOpen: boolean) => () => {
    setOpen(newOpen);
  };
  return (
    <AppBar
      position="fixed"
      sx={{
        display: { xs: "auto", md: "none" },
        boxShadow: 0,
        bgcolor: "background.paper",
        backgroundImage: "none",
        borderBottom: "1px solid",
        borderColor: "divider",
        top: "var(--template-frame-height, 0px)",
      }}
    >
      <Toolbar variant="regular">
        <Stack
          direction="row"
          sx={{
            justifyContent: "space-between",
            alignItems: "center",
            flexGrow: 1,
            width: "100%",
          }}
        >
          <Stack
            direction="row"
            spacing={1}
            sx={{ justifyContent: "center" }}
          >
            <img
              onClick={() => navigate("/")}
              src={logo}
              alt="Logo"
              style={{ height: "40px" }}
            />
          </Stack>
          <MenuButton
            aria-label="menu"
            sx={{
              justifyContent: "space-between",
            }}
            onClick={toggleDrawer(true)}
          >
            <MenuSharpIcon />
          </MenuButton>
          <SideMenuMobile open={open} toggleDrawer={toggleDrawer} />
        </Stack>
      </Toolbar>
    </AppBar>
  );
}
